import { CSSProperties } from "react";

export const flexCentered: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
